/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptDetailController', DeptDetailController);

    DeptDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dept', 'Profile', 'Payment', 'Booking', 'Activities', 'Project', 'DinghyEvent'];

    function DeptDetailController($scope, $rootScope, $stateParams, previousState, entity, Dept, Profile, Payment, Booking, Activities, Project, DinghyEvent) {
        var vm = this;

        vm.dept = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:deptUpdate', function(event, result) {
            vm.dept = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
